import React from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser'

import './renderHTML.component.css'

const RenderHTML = (props) => {
  const { theme, html } = props

  return (
    <div className={`render-html render-html--${theme}`}>
      {parse(html)}
    </div>
  )
}

RenderHTML.propTypes = {
  html: PropTypes.string.isRequired
}

export default RenderHTML
